/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Advanced configuration options specific to Aurora cluster PITR restore.
*/
export class RdsNativePitrClusterAdvancedConfig {
  /**
  * KMS key identifier for encrypting the restored Aurora cluster.  Note: This option is only available for Aurora clusters, not RDS instances. RDS instances inherit encryption from the source instance.  If not specified, the cluster inherits the encryption from the source cluster. 
  */
  'encryptionKeyId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "encryptionKeyId",
      "baseName": "encryptionKeyId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RdsNativePitrClusterAdvancedConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

